<template>
  <ApolloMutation
    :mutation="
      (gql) => gql`
        mutation CreateStoryContribution(
          $story: String
          $contributor: String
          $role: String!
          $contributorWebsite: String
        ) {
          createStoryContribution(
            input: {
              story: $story
              contributor: $contributor
              role: $role
              contributorWebsite: $contributorWebsite
            }
          ) {
            storyContribution {
              id
              contributor {
                id
                userProfile {
                  id
                  username
                  firstName
                  lastName
                  image {
                    contentUrl
                  }
                }
              }
              contributorWebsite
              role {
                id
                _id
              }
            }
          }
        }
      `
    "
    :variables="{
      story: storyId,
      contributor: userId,
      contributorWebsite: contributorWebsite,
      role: roleId,
    }"
    :update="updateCache"
  >
    <template v-slot="{ mutate, loading }">
      <v-btn
        color="primary"
        :loading="loading"
        @click="mutate()"
        :disabled="!active"
        >{{ $t("storyHub.publishing.wizard.addNewContributor") }}</v-btn
      >
    </template>
  </ApolloMutation>
</template>
<script>
import gql from "graphql-tag";
import iris from "@/iris";
export default {
  props: {
    user: [Object, String],
    roleId: String,
  },
  methods: {
    updateCache(store, { data: { createStoryContribution } }) {
      this.$emit("added");

      const identifiableStory = {
        id: this.storyId,
        __typename: "Story",
      };

      store.modify({
        id: store.identify(identifiableStory),
        fields: {
          storyContributions(
            existingStoryContributionRefs = [],
            { readField }
          ) {
            const newStoryContributionRef = store.writeFragment({
              data: createStoryContribution.storyContribution,
              fragment: gql`
                fragment NewStoryContribution on StoryContribution {
                  id
                }
              `,
            });
            if (
              existingStoryContributionRefs.some(
                (ref) =>
                  readField("id", ref) ===
                  createStoryContribution.storyContribution.id
              )
            ) {
              return existingStoryContributionRefs;
            }

            return [...existingStoryContributionRefs, newStoryContributionRef];
          },
        },
      });
    },
  },
  computed: {
    active() {
      return (
        this.storyId &&
        this.storyId != "" &&
        ((this.userId && this.userId != "") ||
          (this.contributorWebsite && this.contributorWebsite != "")) &&
        this.roleId &&
        this.roleId != ""
      );
    },
    userId() {
      if (typeof this.user == "object") {
        return this.user && this.user.id;
      }
      return null;
    },
    contributorWebsite() {
      if (typeof this.user == "string") {
        return this.user;
      }
      return null;
    },
    storyId() {
      return iris.story + this.$route.params.id;
    },
  },
};
</script>

